export default "__VITE_ASSET__BeC0OxW4__"